import React from 'react';

import Element from '~/src/components/element/Element';

import css from './InterviewSegment.module.scss';

const InterviewSegment = ({question, answers}) => {
    return (
        <React.Fragment>
            <p className={css.question}>
                <Element {...question} />
            </p>

            {answers.map((answer, index) => {
                return (
                    <p key={index} className={css.answer}>
                        <Element {...answer} />
                    </p>
                );
            })}
        </React.Fragment>
    );
};

export default InterviewSegment;
